module.exports = __webpack_public_path__ + "static/media/appslogo.b91f4b72.png";